module.exports = __webpack_public_path__ + "static/media/Gorilla Man.34da3b55.jpg";